import * as React from 'react';
import { Modal } from 'antd';

import { BaseModal, BaseModalProps, baseRender } from '../BaseModal/BaseModal';
import { BaseModalContent, BaseModalContentProps } from '../BaseModal/BaseModalContent';

interface ModalConfirmProps extends BaseModalProps {}

export const ModalConfirm = (props: ModalConfirmProps) => {
  const { children, ...rest } = props;

  return (
    <BaseModal {...rest}>
      <BaseModalContent {...rest}>{children}</BaseModalContent>
    </BaseModal>
  );
};

ModalConfirm.create = () => {
  const modal = Modal.confirm({});
  const render = (renderNode: () => React.ReactNode, props?: BaseModalContentProps) => {
    baseRender<BaseModalContentProps>({
      modal,
      renderComponent: (contentProps) => (
        <BaseModalContent {...contentProps}>{renderNode()}</BaseModalContent>
      ),
      props,
    });
  };
  return {
    modal,
    render,
  };
};
